import root from '../../_helpers/roots';
import axios from 'axios';
import moment from 'moment';
import toast from '../../services/toast';
import feedbackForm from '../contestFeedbackForm/index';
var interval;
import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import VueCircle from 'vue2-circle-progress/src/index.vue'
import Vue from 'vue'
export default {
  name: 'contest-quizzort',
  components: {
    VueCircle,
    'feedback-form':feedbackForm
  },
  props: ['quiz', 'totalTime', 'quizInst'],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      questionIndex: 0,
      userResponses: [],
      quizResponses: [],
      quizStarted: true,
      isActive: false,
      totalScore: 0,
      quizId: '',
      quizSubmitted: false,
      QuizStart: false,
      firstQuizStart: false,
      secondQuizStart: false,
      quizSectionShow: false,
      quizInstructionsShow: true,
      firstSectionCountDown: {
        minutes: "00",
        seconds: "00"
      },
      CountDown: {
        minutes: "00",
        seconds: "00"
      },
      secondSectionCountDown: {
        minutes: "00",
        seconds: "00"
      },
      questionIndexs: ['', 'A', 'B', 'C', 'D'],
      newArray: [],
      sectionQuestion: '',
      sectionQuestionList: [],
      sectionQuestionListResults: [],
      selectedQuestionId: '',
      selectedOptionData: '',
      selectedQuestionIndex: '',
      sectionByTotalTime: '',
      firstSectionByTotalTime: '',
      secondSectionByTotalTime: '',
      firstSectionQueList: '',
      secondSectionQueList: '',
      secondQuizStartCheck:false,
      firstQuizStartCheck:false,
      firstQuestionIndex:'1',
      secondQuestionIndex:'1',
      selectedOptionIndex:'',
      selectedOptionId:'',
      startTimerCheck:true,
      skipQuestion:true,
      contestFeedbackTrue:false,
      checkContestFeedbackButton:true,
      contestTestingRouterCheck:'',
      sectionQuesCountFirstTitle:'',
      sectionQuesCountSecondTitle:'',
    }
  },
  computed: {
    getRouterTestingCheckFun(){
      this.contestTestingRouterCheck = this.$route.name
    }
  },
  mounted() {
    // console.log(this.quiz, "Contest Quiz Details")
    $('.quizloader, .courseloader').hide();
    this.quizId = this.$route.params.quizId;
    // this.getCounter();
    this.renderMathJax()
    setInterval(() => {
    this.renderMathJax()
    },10);
    // $('#js-resetTimer').click(function () {
    //   $('.js-timeout').text("0:10");
    //   clearInterval(interval);
    // });
    bus.$on('contestFeedbackBus', (data) => {
      this.contestFeedbackTrue = data;
    })
    bus.$on('checkContestFeedbackBtnBus', (data) => {
      this.checkContestFeedbackButton = data;
    })
    this.getRouterTestingCheckFun
    if(this.contestTestingRouterCheck == 'contestQuiz'){
      this.countdownTimer();
    }
  },
  methods: {
    feedbackFormActive(){
      this.contestFeedbackTrue = true
    },
    countdownTimer() {
      var __self = this
      clearInterval(interval);
      interval = setInterval( function() {
          var timer = $('.js-timeout').html();
          timer = timer.split(':');
          var minutes = timer[0];
          var seconds = timer[1];
          seconds -= 1;
          if (minutes < 0) return;
          else if (seconds < 0 && minutes != 0) {
              minutes -= 1;
              seconds = 59;
          }
          else if (seconds < 10 && length.seconds != 2) seconds = '0' + seconds;
          $('.js-timeout').html(minutes + ':' + seconds);
          if (minutes == 0 && seconds == 0){
            __self.startTimerCheck = false
            // console.log("Check Count Down Timer")
            clearInterval(interval)
          };
      }, 1000);
    },
    renderMathJax() {
      setTimeout(() => {
        if (window.MathJax) {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log());
        }
      }, 100)
    },
    contestSectionShow() {
      // this.quizStart = true;
      this.quizSectionShow = true
      this.quizInstructionsShow = false
    },
    getCounter() {
      let startIndex = this.questionIndex;
      let maxCount = 5;
      let maxQuestions = this.sectionQuestionListResults.length;
      let finalArray = [];
      let maxNumber = maxCount + startIndex;
      if (maxQuestions > 5) {
        for (let i = startIndex; i < maxNumber; i++) {
          finalArray.push(i + 1);
        }
        if (maxNumber <= maxQuestions)
          this.newArray = finalArray;
      } else {
        for (let i = 0; i < maxQuestions; i++) {
          finalArray.push(i + 1);
        }
        this.newArray = finalArray;
      }
    },
    startQuiz: function (sectionIndex) {
      $('.quizloader,.courseloader').show();
      bus.$emit('contestAlertShown', true);
      // console.log(this.contestTestingRouterCheck, "Router CHeck for Contest")
      if(this.contestTestingRouterCheck == 'contestQuiz'){
        var randomNum = Math.floor((Math.random() * 15) + 1);
        let quizListUrlLink = root.contestQuizDetailLink.link + this.$route.params.quizId + '/' + '?random=' + randomNum + '&user_local_date=' + moment.utc().format();
        axios.get(quizListUrlLink).then(response => {
          if (response.status === 200) {
            this.sectionQuestion = response.data.data.sections
            this.sectionQuesCountFirstTitle = this.sectionQuestion[0].name
            this.sectionQuesCountSecondTitle = this.sectionQuestion[1].name
            for (var i = 0; i < this.sectionQuestion.length; i++) {
              this.sectionQuestionList.push(this.sectionQuestion[i].questions)
            }
            if (sectionIndex == 0) {
              // console.log("First Section Active")
              this.firstQuizStart = true
              this.firstQuizStartCheck = true
              var sectionList0 = this.sectionQuestionList[0]
              var sectionList1 = this.sectionQuestionList[1]
              this.firstSectionQueList = this.sectionQuestionList[0]
              this.secondSectionQueList = this.sectionQuestionList[1]
              this.sectionQuestionListResults = sectionList0.concat(sectionList1);
              this.firstSectionByTotalTime = this.sectionQuestion[0].allocated_time
              this.secondSectionByTotalTime = this.sectionQuestion[1].allocated_time
              this.sectionByTotalTime = this.sectionQuestion[0].allocated_time + this.sectionQuestion[1].allocated_time
              var totalTimes = new Date();
              totalTimes.setSeconds(totalTimes.getSeconds() + this.firstSectionByTotalTime);
              this.firstInitializeTimer(totalTimes);
            } else {
              // console.log("Second Section Active")
              this.secondQuizStart = true
              this.secondQuizStartCheck = true
              var sectionList0 = this.sectionQuestionList[0]
              var sectionList1 = this.sectionQuestionList[1]
              this.firstSectionQueList = this.sectionQuestionList[0]
              this.secondSectionQueList = this.sectionQuestionList[1]
              this.sectionQuestionListResults = sectionList1.concat(sectionList0);
              this.firstSectionByTotalTime = this.sectionQuestion[0].allocated_time
              this.secondSectionByTotalTime = this.sectionQuestion[1].allocated_time
              this.sectionByTotalTime = this.sectionQuestion[0].allocated_time + this.sectionQuestion[1].allocated_time
              var totalTimes1 = new Date();
              totalTimes1.setSeconds(totalTimes1.getSeconds() + this.secondSectionByTotalTime);
              // console.log(this.secondSectionByTotalTime, "Second Contst After Start")
              this.secondInitializeTimer(totalTimes1);
            }
            var totalTimes = new Date();
            totalTimes.setSeconds(totalTimes.getSeconds() + this.sectionByTotalTime);
            this.initializeTimer(totalTimes);
            this.quizSectionShow = false;
            this.QuizStart = true
            // this.renderMathJax();
            this.getCounter()
            $('.quizloader,.courseloader').hide();
          }
        }).catch(error => {
          if(error.status === 404) {
            toast.error(error.statusText);
            this.$router.go(-1);
            $('.quizloader,.courseloader').hide();
          } else {
            toast.error(error.data.data.message);
            this.$router.go(-1);
            $('.quizloader,.courseloader').hide();
          }
        })
      }else{
        var randomNum = Math.floor((Math.random() * 15) + 1);
        let quizListUrlLink = root.contestQuizDetailLink.link + this.$route.params.quizId + '/' + '?random=' + randomNum + '&user_local_date=' + moment.utc().format() + '&testing_enabled=' + 1;
        axios.get(quizListUrlLink).then(response => {
          if (response.status === 200) {
            this.sectionQuestion = response.data.data.sections
            this.sectionQuesCountFirstTitle = this.sectionQuestion[0].name
            this.sectionQuesCountSecondTitle = this.sectionQuestion[1].name
            for (var i = 0; i < this.sectionQuestion.length; i++) {
              this.sectionQuestionList.push(this.sectionQuestion[i].questions)
            }
            if (sectionIndex == 0) {
              // console.log("First Section Active")
              this.firstQuizStart = true
              this.firstQuizStartCheck = true
              var sectionList0 = this.sectionQuestionList[0]
              var sectionList1 = this.sectionQuestionList[1]
              this.firstSectionQueList = this.sectionQuestionList[0]
              this.secondSectionQueList = this.sectionQuestionList[1]
              this.sectionQuestionListResults = sectionList0.concat(sectionList1);
              this.firstSectionByTotalTime = this.sectionQuestion[0].allocated_time
              this.secondSectionByTotalTime = this.sectionQuestion[1].allocated_time
              this.sectionByTotalTime = this.sectionQuestion[0].allocated_time + this.sectionQuestion[1].allocated_time
              var totalTimes = new Date();
              totalTimes.setSeconds(totalTimes.getSeconds() + this.firstSectionByTotalTime);
              this.firstInitializeTimer(totalTimes);
            } else {
              // console.log("Second Section Active")
              this.secondQuizStart = true
              this.secondQuizStartCheck = true
              var sectionList0 = this.sectionQuestionList[0]
              var sectionList1 = this.sectionQuestionList[1]
              this.firstSectionQueList = this.sectionQuestionList[0]
              this.secondSectionQueList = this.sectionQuestionList[1]
              this.sectionQuestionListResults = sectionList1.concat(sectionList0);
              this.firstSectionByTotalTime = this.sectionQuestion[0].allocated_time
              this.secondSectionByTotalTime = this.sectionQuestion[1].allocated_time
              this.sectionByTotalTime = this.sectionQuestion[0].allocated_time + this.sectionQuestion[1].allocated_time
              var totalTimes1 = new Date();
              totalTimes1.setSeconds(totalTimes1.getSeconds() + this.secondSectionByTotalTime);
              // console.log(this.secondSectionByTotalTime, "Second Contst After Start")
              this.secondInitializeTimer(totalTimes1);
            }
            var totalTimes = new Date();
            totalTimes.setSeconds(totalTimes.getSeconds() + this.sectionByTotalTime);
            this.initializeTimer(totalTimes);
            this.quizSectionShow = false;
            this.QuizStart = true
            // this.renderMathJax();
            this.getCounter()
            $('.quizloader,.courseloader').hide();
          }
        }).catch(err => {
          if (err.status == '400' || err.status == '403') {
            this.$router.push('/contest/')
            $('.quizloader,.courseloader').hide();
            toast.error(err.data.data.message);
          }else{
            toast.error(err.data.data.message);
            this.$router.go(-1);
            $('.quizloader,.courseloader').hide();
          }
        })
      }
    },
    submitQuiz: function () {
      $('.quizloader').show();
      let quizCreateAnswerLink = root.quizCreateAnswerLink.link;
      let data = {
        quiz: this.quizId,
        time_taken: (this.sectionByTotalTime * 1000 - this.CountDown.total) / 1000,
        // time_taken:this.CountDown.total,
        questions: this.quizResponses
      };
      // console.log(data, "Sending Que And Ans List");
      axios.post(quizCreateAnswerLink, data).then(response => {
          this.quizSubmitted = true;
          bus.$emit('contestAlertHideCompleted', true);
          this.totalScore = response.data.data.points_obtained;
          $('.quizloader').hide();
      }).catch(err => {
        console.error(err);
        $('.quizloader').hide();
      })
    },
    selectOption: function (index, optionData, questionId) {
      this.selectedQuestionId = questionId
      this.selectedOptionData = optionData
      this.selectedQuestionIndex = index
      if(this.selectedOptionData != this.selectedOptionId){
        this.selectedOptionId = this.selectedOptionData
        Vue.set(this.userResponses, this.questionIndex, this.selectedQuestionIndex);
        this.skipQuestion = false
      }else{
        Vue.delete(this.userResponses, this.questionIndex, this.selectedQuestionIndex);
        this.selectedOptionData = '',
        this.selectedQuestionId = '',
        this.selectedQuestionIndex = '',
        this.selectedOptionId = '',
        this.skipQuestion = true
      }
      // console.log( this.selectedOptionId,this.selectedOptionData, "Selected Option Data")
    },
    next: function () {
      // console.log("Next Click")
      if (this.questionIndex + 1 == this.sectionQuestionListResults.length) {
        this.score()
        // this.renderMathJax()
      } else if (this.questionIndex < this.sectionQuestionListResults.length) {
        this.questionIndex++;
        if (this.secondQuizStartCheck == true) {
          if (this.questionIndex == this.secondSectionQueList.length) {
            this.questionIndex = this.secondSectionQueList.length
            clearInterval(this.secondtimeinterval);
            this.secondQuizStart = false
            this.firstQuizStart = true
            var totalTimes = new Date();
            totalTimes.setSeconds(totalTimes.getSeconds() + this.firstSectionByTotalTime);
            // console.log(this.firstSectionByTotalTime,this.firstQuizStart, "Start First Section Contest!!!!!!!")
            this.firstAfterSecondInitializeTimer(totalTimes);
          } else {
            if(this.secondQuestionIndex < this.secondSectionQueList.length){
              this.secondQuestionIndex++;
              // console.log(this.secondQuestionIndex, "Second Question Index")
            }else{
              this.firstQuestionIndex++;
              // console.log(this.firstQuestionIndex, "First Question Index")
            }
          }
        } else if (this.firstQuizStartCheck == true) {
          if (this.questionIndex == this.firstSectionQueList.length) {
            this.questionIndex = this.firstSectionQueList.length
            clearInterval(this.firsttimeinterval);
            this.firstQuizStart = false
            this.secondQuizStart = true
            var totalTimes = new Date();
            totalTimes.setSeconds(totalTimes.getSeconds() + this.secondSectionByTotalTime);
            this.secondAfterFirstInitializeTimer(totalTimes);
            // console.log(this.secondSectionByTotalTime, "Start Second Section Contest!!!!!!!")
          } else {
            if(this.firstQuestionIndex < this.firstSectionQueList.length){
              this.firstQuestionIndex++;
              // console.log(this.firstQuestionIndex, "First Question Index")
            }else{
              this.secondQuestionIndex++;
              // console.log(this.secondQuestionIndex, "Second Question Index")
            }
          }
        }
        this.getCounter();
        this.skipQuestion = true
        // this.renderMathJax()
      }
      if(this.selectedQuestionId && this.selectedOptionData){
        this.quizResponses.push({
          "question": this.selectedQuestionId,
          "options": [{
            "option": this.selectedOptionData
          }]
        })
        this.selectedQuestionId = ''
        this.selectedOptionData = ''
      }
    },
    prev: function () {
      if (this.sectionQuestionListResults.length > 0) this.questionIndex--;
      // this.renderMathJax()
    },
    // Return "true" count in userResponses
    score: function (showScrore = false) {
      this.submitQuiz();
    },
    // All Section  CountDown
    initializeTimer: function (endTime) {
      // console.log(endTime, "Contest End Time")
      var _self = this;
      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.CountDown = remainTime;
        // _self.UpdatePercentage(remainTime.total);
        // console.log('Time End Before')
        if (remainTime.total <= 0 && _self.quizSubmitted == false) {
          _self.submitQuiz();
          // console.log('Time End')
          clearInterval(_self.timeinterval);
        }
      }
      updateClock();
      _self.timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    // First Section  CountDown
    firstInitializeTimer: function (endTime) {
      var _self = this;
      function updateClockFirst() {
        let remainTime = _self.getTimeRemainingFirst(endTime)
        // console.log(remainTime, "First Contest Timer Start")
        _self.firstSectionCountDown = remainTime;
        // _self.UpdatePercentage(remainTime.total);
        // console.log('Time End Before')
        if (remainTime.total <= 0 && _self.quizSubmitted == false) {
          _self.questionIndex = _self.firstSectionQueList.length - 1
          _self.firstQuestionIndex = _self.firstSectionQueList.length
          _self.next();
          // console.log(_self.questionIndex, 'First Contest Timer End')
          clearInterval(_self.firsttimeinterval);
        }
      }
      updateClockFirst();
      _self.firsttimeinterval = setInterval(updateClockFirst, 1000);
    },
    getTimeRemainingFirst(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    // First Section After Second  CountDown
    firstAfterSecondInitializeTimer: function (endTime) {
      // console.log('First Section After Second  CountDown', endTime)
      var _self = this;
      function updateClockFirstAfterSecond() {
        let remainTime = _self.getTimeRemainingFirstAfterSecond(endTime)
        _self.firstSectionCountDown = remainTime;
        if (remainTime.total <= 0 && _self.quizSubmitted == false) {
          _self.submitQuiz();
          clearInterval(_self.firsttimeintervalFirstAfterSecond);
        }
      }
      updateClockFirstAfterSecond();
      _self.firsttimeintervalFirstAfterSecond = setInterval(updateClockFirstAfterSecond, 1000);
    },
    getTimeRemainingFirstAfterSecond(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    // UpdatePercentage(remainTime) {
    //   let totalTime = (this.totalTime) * 1000;
    //   let percentage = 100 - ((remainTime * 100) / totalTime)
    //   if (this.$refs.timerRef)
    //     this.$refs.timerRef.updateProgress(percentage);
    // },
    // Second Section  CountDown
    secondInitializeTimer: function (endTime) {
      // console.log(endTime, "Second Contest Time Format")
      var _self = this;
      function updateClockSecond() {
        let remainTime = _self.secondGetTimeRemaining(endTime)
        // console.log(remainTime, "Second Contest End Time")
        _self.secondSectionCountDown = remainTime;
        // _self.UpdatePercentageSecond(remainTime.total);
        // console.log('Time End Before')
        if (remainTime.total <= 0 && _self.quizSubmitted == false) {
          _self.questionIndex = _self.secondSectionQueList.length - 1
          _self.secondQuestionIndex = _self.secondSectionQueList.length
          _self.next();
          // console.log('Second Time End')
          clearInterval(_self.secondtimeinterval);
        }
      }
      updateClockSecond();
      _self.secondtimeinterval = setInterval(updateClockSecond, 1000);
    },
    secondGetTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    // Second Section After First CountDown
    secondAfterFirstInitializeTimer: function (endTime) {
      var _self = this;
      function updateClockSecondAfterFirst() {
        let remainTime = _self.secondAfterFirstGetTimeRemaining(endTime)
        _self.secondSectionCountDown = remainTime;
        if (remainTime.total <= 0 && _self.quizSubmitted == false) {
          _self.submitQuiz();
          clearInterval(_self.secondAfterFirsttimeinterval);
        }
      }
      updateClockSecondAfterFirst();
      _self.secondAfterFirsttimeinterval = setInterval(updateClockSecondAfterFirst, 1000);
    },
    secondAfterFirstGetTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    // UpdatePercentageSecond(remainTime) {
    //   let totalTime = (this.totalTime) * 1000;
    //   let percentage = 100 - ((remainTime * 100) / totalTime)
    //   if (this.$refs.timerRef)
    //     this.$refs.timerRef.updateProgress(percentage);
    // }
  },
  beforeDestroy() {
    clearInterval(this.timeinterval);
    clearInterval(this.firsttimeinterval);
    clearInterval(this.secondtimeinterval);
    clearInterval(this.firsttimeintervalFirstAfterSecond)
    clearInterval(this.secondAfterFirsttimeinterval)
    clearInterval(interval);
  },
  created() {
  },
  watch: {
    getRouterTestingCheckFun(){
      this.contestTestingRouterCheck = this.$route.name
    },
  },
}
